export const FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED = 'FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED'
export const PUT_PROJECT_STATUS_SUCCEEDED = 'PUT_PROJECT_STATUS_SUCCEEDED'
export const CHANGE_MODERATOR_REQUESTED = 'CHANGE_MODERATOR_REQUESTED'
export const CHANGE_MODERATOR_SUCCEEDED = 'CHANGE_MODERATOR_SUCCEEDED'
export const CHANGE_MODERATOR_FAILED = 'CHANGE_MODERATOR_FAILED'
export const LAUNCH_SURVEYS_REQUESTED = 'LAUNCH_SURVEYS_REQUESTED'
export const LAUNCH_SURVEYS_FAILED = 'LAUNCH_SURVEYS_FAILED'
export const LAUNCH_SURVEYS_SUCCEEDED = 'LAUNCH_SURVEYS_SUCCEEDED'
export const CLOSE_SURVEYS_REQUESTED = 'CLOSE_SURVEYS_REQUESTED'
export const CLOSE_SURVEYS_FAILED = 'CLOSE_SURVEYS_FAILED'
export const CLOSE_SURVEYS_SUCCEEDED = 'CLOSE_SURVEYS_SUCCEEDED'
export const ADD_OBSERVERS_TO_PROJECT_SUCCEEDED = 'ADD_OBSERVERS_TO_PROJECT_SUCCEEDED'
export const TOGGLE_PAUSE_WARNING_REQUESTED = 'TOGGLE_PAUSE_WARNING_REQUESTED'
export const TOGGLE_EDIT_WARNING_REQUESTED = 'TOGGLE_EDIT_WARNING_REQUESTED'
export const TOGGLE_PROJECT_COMPLETE_WARNING = 'TOGGLE_PROJECT_COMPLETE_WARNING'
export const INIT_LAUNCH_SURVEYS_REQUESTED = 'INIT_LAUNCH_SURVEYS_REQUESTED'
export const SHOW_REVIEW_MODAL_REQUESTED = 'SHOW_REVIEW_MODAL_REQUESTED'
export const CLOSE_REVIEW_MODAL_REQUESTED = 'CLOSE_REVIEW_MODAL_REQUESTED'
export const TOGGLE_COMPLETIONS_WARNING_REQUESTED = 'TOGGLE_COMPLETIONS_WARNING_REQUESTED'
export const CLEAR_PROJECT_INQUIRY = 'CLEAR_PROJECT_INQUIRY'
export const NEW_PROJECT_CREATED = 'NEW_PROJECT_CREATED'
export const FINALIZE_PROJECT_SUCCEEDED = 'FINALIZE_PROJECT_SUCCEEDED'
export const REOPEN_PROJECT_SUCCEEDED = 'REOPEN_PROJECT_SUCCEEDED'
export const FETCH_ALL_DASHBOARD_INFO_SUCCEEDED = 'FETCH_ALL_DASHBOARD_INFO_SUCCEEDED'
export const UPDATE_PROJECT_MODERATORS_SUCCEEDED = 'UPDATE_PROJECT_MODERATORS_SUCCEEDED'
export const EDIT_SAMPLE_SIZE_SUCCEEDED = 'EDIT_SAMPLE_SIZE_SUCCEEDED'
export const UPDATE_PROJECT_SAMPLE_SIZE = 'UPDATE_PROJECT_SAMPLE_SIZE'
export const POST_CONFERENCE_LINK_DETAILS_SUCCESSED = 'POST_CONFERENCE_LINK_DETAILS_SUCCESSED'
export const POST_CONFERENCE_LINK_DETAILS_FAILED = 'POST_CONFERENCE_LINK_DETAILS_FAILED'
export const POST_CONFERENCE_LINK_DETAILS_REQUESTED = 'POST_CONFERENCE_LINK_DETAILS_REQUESTED'
export const GET_CONFERENCE_LINK_DETAILS_REQUESTED = 'GET_CONFERENCE_LINK_DETAILS_REQUESTED'
export const UPDATE_CONFERENCE_LINK_DETAILS_REQUESTED = 'UPDATE_CONFERENCE_LINK_DETAILS_REQUESTED'
export const UPDATE_CONFERENCE_LINK_DETAILS_SUCCESSED = 'UPDATE_CONFERENCE_LINK_DETAILS_SUCCESSED'
export const UPDATE_CONFERENCE_LINK_DETAILS_FAILED= 'UPDATE_CONFERENCE_LINK_DETAILS_FAILED'
export const TOGGLE_EDIT_CONFERENCE_LINK_CONFIRMATION_MODAL = 'TOGGLE_EDIT_CONFERENCE_LINK_CONFIRMATION_MODAL'
export const UPDATE_PROJECT_INFO_REQUESTED = 'UPDATE_PROJECT_INFO_REQUESTED'
export const UPDATE_PROJECT_INFO_SUCCESSED = 'UPDATE_PROJECT_INFO_SUCCESSED'
export const UPDATE_PROJECT_INFO_FAILED = 'UPDATE_PROJECT_INFO_FAILED'
export const UPDATE_PROJECT_SURVEY_ID_REQUESTED = 'UPDATE_PROJECT_SURVEY_ID_REQUESTED'
export const UPDATE_PROJECT_SURVEY_ID_SUCCESSED = 'UPDATE_PROJECT_SURVEY_ID_SUCCESSED'
export const UPDATE_PROJECT_SURVEY_ID_FAILED = 'UPDATE_PROJECT_SURVEY_ID_FAILED'
export const UPDATE_PROJECT_SAMPLE_SIZE_SUCCESSED = 'UPDATE_PROJECT_SAMPLE_SIZE_SUCCESSED'
export const GET_AVAILABLE_MODERATORS_COUNT_FAILED = 'GET_AVAILABLE_MODERATORS_COUNT_FAILED'
export const GET_AVAILABLE_MODERATORS_COUNT_REQUESTED ='GET_AVAILABLE_MODERATORS_COUNT_REQUESTED'
export const GET_AVAILABLE_MODERATORS_COUNT_SUCCESSED = 'GET_AVAILABLE_MODERATORS_COUNT_SUCCESSED'
export const UPDATE_PROJECT_SAMPLE_SIZE_REQUESTED = 'UPDATE_PROJECT_SAMPLE_SIZE_REQUESTED'
export const UPDATE_PROJECT_SAMPLE_SIZE_FAILED = 'UPDATE_PROJECT_SAMPLE_SIZE_FAILED'
export const UPDATE_PROJECT_MODERATORS_FAILED = 'UPDATE_PROJECT_MODERATORS_FAILED'
export const TOGGLE_ADD_MODERATORS_MODAL = 'TOGGLE_ADD_MODERATORS_MODAL'
export const UPDATE_PROJECT_MODERATORS_REQUESTED = 'UPDATE_PROJECT_MODERATORS_REQUESTED'
export const DELETE_PROJECT_MODERATOR_REQUESTED = 'DELETE_PROJECT_MODERATOR_REQUESTED'
export const DELETE_PROJECT_MODERATOR_SUCCEEDED = 'DELETE_PROJECT_MODERATOR_SUCCEEDED'
export const DELETE_PROJECT_MODERATOR_FAILED = 'DELETE_PROJECT_MODERATOR_FAILED'
export const GET_UNAVAILABLE_MODERATORS_FAILED = 'GET_UNAVAILABLE_MODERATORS_FAILED'
export const GET_UNAVAILABLE_MODERATORS_SUCCESSED = 'GET_UNAVAILABLE_MODERATORS_SUCCESSED'
export const GET_UNAVAILABLE_MODERATORS_REQUESTED = 'GET_UNAVAILABLE_MODERATORS_REQUESTED'
export const TOGGLE_TIME_RANGE_MODAL = 'TOGGLE_TIME_RANGE_MODAL'
export const PUT_MODERATOR_TIME_RANGE_RQUESTED = 'PUT_MODERATOR_TIME_RANGE_RQUESTED'
export const PUT_MODERATOR_TIME_RANGE_SUCCESSED = 'PUT_MODERATOR_TIME_RANGE_SUCCESSED'
export const PUT_MODERATOR_TIME_RANGE_FAILED = 'PUT_MODERATOR_TIME_RANGE_FAILED'
export const TOGGLE_UNABLE_TO_REMOVE_MOD_MODAL = 'TOGGLE_UNABLE_TO_REMOVE_MOD_MODAL'
export const UPDATE_INTERVIEW_BUFFER_REQUESTED = 'UPDATE_INTERVIEW_BUFFER_REQUESTED'
export const UPDATE_INTERVIEW_BUFFER_SUCCESSED = 'UPDATE_INTERVIEW_BUFFER_SUCCESSED'
export const UPDATE_INTERVIEW_BUFFER_FAILED = 'UPDATE_INTERVIEW_BUFFER_FAILED'
export const TOGGLE_TRANSLATIONS_MODAL = 'TOGGLE_TRANSLATIONS_MODAL'
export const POST_TRANSLATIONS_REQUESTED = 'POST_TRANSLATIONS_REQUESTED'
export const POST_TRANSLATIONS_SUCCESSED = 'POST_TRANSLATIONS_SUCCESSED'
export const POST_TRANSLATIONS_FAILED = 'POST_TRANSLATIONS_FAILED'
export const SET_MEETING_INFORMATION_PER_LANGUAGE  = 'SET_MEETING_INFORMATION_PER_LANGUAGE'
export const GET_LANG_LOC_SUCCESSED = 'GET_LANG_LOC_SUCCESSED'
export const GET_LANG_LOC_FAILED = 'GET_LANG_LOC_FAILED'
export const ADD_TRANSLATIONS_REQUESTED = 'ADD_TRANSLATIONS_REQUESTED'
export const CLEAR_TRANSLATIONS = 'CLEAR_TRANSLATIONS'
export const SET_CHOSEN_TRANLSATIONS_LABELS = 'SET_CHOSEN_TRANLSATIONS_LABELS'
export const DELETE_TRANSLATIONS_REQUESTED = 'DELETE_TRANSLATIONS_REQUESTED'
export const DELETE_TOPIC_TRANSLATIONS_REQUESTED = 'DELETE_TOPIC_TRANSLATIONS_REQUESTED'
export const DELETE_TRANSLATIONS_FAILED = 'DELETE_TRANSLATIONS_FAILED'
export const DELETE_TOPIC_TRANSLATIONS_FAILED = 'DELETE_TOPIC_TRANSLATIONS_FAILED'
export const DELETE_TRANSLATIONS_SUCCESSED = 'DELETE_TRANSLATIONS_SUCCESSED'
export const DELETE_TOPIC_TRANSLATIONS_SUCCESSED = 'DELETE_TOPIC_TRANSLATIONS_SUCCESSED'
export const TOGGLE_INCONSISTENT_MEETING_INFORMATION_MODAL = 'TOGGLE_INCONSISTENT_MEETING_INFORMATION_MODAL'
export const TOGGLE_TRANSLATIONS_ERROR_MODAL = 'TOGGLE_TRANSLATIONS_ERROR_MODAL'
export const TOGGLE_TOPIC_TRANSLATIONS_ERROR_MODAL = 'TOGGLE_TOPIC_TRANSLATIONS_ERROR_MODAL'
export const ADD_TOPIC_NAME_TRANSLATIONS_REQUESTSED = 'ADD_TOPIC_NAME_TRANSLATIONS_REQUESTSED'
export const ADD_TOPIC_NAME_TRANSLATIONS_SUCCESSED = 'ADD_TOPIC_NAME_TRANSLATIONS_SUCCESSED'
export const ADD_TOPIC_NAME_TRANSLATIONS_FAILED = 'ADD_TOPIC_NAME_TRANSLATIONS_FAILED'
